<template>
    <div v-if="item" class="mobile-menu mobile-menu--simple">
        <div class="mobile-menu__container js-mobile-menu-container">
            <div class="mobile-menu__container-inner">
                <div class="product-info">
                    <div class="product-info-img-wrap">
                        <div class="product-info-img" v-if="item.product.thumb_image" :style="`background-image: url(${item.product.thumb_image})`"></div>
                        <div v-else class="product-info-no-img"></div>
                    </div>
                    <div class="product-info-content">
                        <div class="product-info-header">
                            <div class="product-info-title">{{ item.product.name }}</div>
                            <div class="product-info-price">{{ item.product.price | currency }}</div>
                        </div>
                        <div class="product-info-description">
                            <template v-if="item.product.photos_quantity">{{ $tc('n_photos_2', item.product.photos_quantity, {amount_total_photos: item.product.photos_quantity}) }}</template><template v-if="item.product.products">{{ $tc('n_products', item.product.products.length, {amount: item.product.products.length}) }}</template><template v-if="item.product.snippet">, {{ item.product.snippet }}</template><template v-if="item.product.product_variant_name">, {{ item.product.product_variant_name }}</template>
                        </div>
                    </div>
                </div>
                <div class="mobile-menu__content">
                    <ul class="mobile-menu__links">
                        <li class="mobile-menu__link">
                            <a href="#" @click.prevent="edit(getAlbumId(item.album), item.product.uuid, item.product.products ? item.product : false)" class="justify-content-start">
                                <span class="material-icon icon-create"/>
                                <span class="text-with-icon">{{ $t('edit_photos') }}</span>
                            </a>
                        </li>
                        <li class="mobile-menu__link">
                            <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_CART_DELETE_MENU', true)" class="justify-content-start">
                                <span class="material-icon icon-delete"/>
                                <span class="text-with-icon">{{ $t('delete_product') }}</span>
                            </a>
                        </li>
                        <li class="mobile-menu__link">
                            <a href="#" @click.prevent="goToAlbum(item.album)" class="justify-content-start">
                                <span class="material-icon icon-undo"/>
                                <span class="text-with-icon">{{ $t('back_to_gallery') }}</span>
                            </a>
                        </li>
                        <!--<li class="mobile-menu__link">
                            <a href="#" @click.prevent="" class="justify-content-start">
                                <span class="material-icon icon-error_outline"/>
                                <span class="text-with-icon">{{ $t('product_information') }}</span>
                            </a>
                        </li>-->
                    </ul>
                </div>
            </div>
        </div>
        <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_CART_MENU', null)" class="mobile-menu__btn -bottom -red">
            <span class="material-icon icon-clear"/>
        </a>
    </div>
</template>

<style lang="scss" scoped>
    .product-info {

        &-img-wrap {
            width: calc(100% + 20px);
            margin: -20px -20px 0;
        }

        &-no-img,
        &-img {
            padding-top: 60%;
            background: 50% 50% no-repeat;
            background-size: cover;
        }

        &-no-img {
            background-image: url('../assets/no-preview-large.jpg');
        }

        &-content {
            padding: 20px 40px;
        }

        &-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
        }

        &-title {
            font-size: 1rem;
        }

        &-description {
            color: var(--text-secondary-color);
            font-size: .87rem;
        }

        &-price {
            font-size: 1.25rem;
        }
    }
</style>

<script>
  import mobileCartMenu from 'src/mixins/mobileCartMenuComponent';
  import cart from 'src/mixins/cartComponent';

  export default {
    mixins: [mobileCartMenu, cart],
  };
</script>
